import { TrendingUp, Search } from "lucide-react";

export const SearchesPanel = ({ topSearches }) => (
  <div className="mt-6" data-testid="searches-panel">
    <div className="rounded-2xl border border-border bg-card p-6 sm:p-8">
      <div className="flex items-center gap-3 mb-2">
        <span className="grid place-items-center h-11 w-11 rounded-xl bg-accent/10 text-accent">
          <TrendingUp className="h-6 w-6" />
        </span>
        <div>
          <h2 className="font-heading font-extrabold text-xl text-foreground">What visitors are searching</h2>
          <p className="text-muted-foreground text-sm">Top “Find Help” searches from the last 7 days.</p>
        </div>
      </div>

      {topSearches.length === 0 ? (
        <div data-testid="searches-empty" className="py-12 text-center">
          <Search className="h-10 w-10 text-muted-foreground mx-auto mb-3" />
          <p className="font-heading font-bold text-lg text-foreground">No searches yet this week</p>
          <p className="mt-1 text-muted-foreground">When visitors use the voice search, their top queries show up here.</p>
        </div>
      ) : (
        <ul className="mt-4 space-y-3">
          {topSearches.map((row, i) => {
            const max = topSearches[0].count || 1;
            const pct = Math.max(8, Math.round((row.count / max) * 100));
            return (
              <li key={row.query} data-testid={`search-row-${i}`} className="flex items-center gap-4">
                <span className="text-muted-foreground font-bold w-6 shrink-0 text-right">{i + 1}</span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-3">
                    <span className="text-foreground font-semibold truncate">“{row.query}”</span>
                    <span className="text-muted-foreground text-sm font-medium shrink-0">
                      {row.count} {row.count === 1 ? "search" : "searches"}
                    </span>
                  </div>
                  <div className="mt-1.5 h-2 rounded-full bg-muted overflow-hidden">
                    <div className="h-full rounded-full bg-accent" style={{ width: `${pct}%` }} />
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  </div>
);
